import { useUIStore } from "../../../../store";
import { useStickyHeader } from "../../../../hooks/useStickHeader";

import { Navbar } from "../Navbar";
import { ContentCarousel } from "../../cards/ContentCarrousel";
import { FormSearch } from "../../forms/FormSearch";

import styles from "./Header.module.scss";

interface Props {
  restaurantName: string;
}

export const Header = ({ restaurantName }: Props) => {
  const showSearch = useUIStore((s) => s.showSearch);
  const section = useUIStore((s) => s.section);

  useStickyHeader(showSearch, section);

  return (
    <div className={styles.containerHeader}>
      {showSearch ? (
        <FormSearch />
      ) : (
        <>
          {section === "home" && (
            <>
              <div className={styles.navbarWrapper}>
                <Navbar restaurantName={restaurantName} />
              </div>

            </>
          )}
        </>
      )}
    </div>
  );
};
